angular.module("Main").controller("BookingKursTooLongController.js", ["$rootScope", "$scope", "$state", "$stateParams", "$window", "$location", "$translate", "PaymentService", "BookingService", "SessionService",
    function ($rootScope, $scope, $state, $stateParams, $window, $location, $translate, PaymentService, BookingService, SessionService) {
        var vm = this;

        getKursbuchungLayouKonfiguration();
        loadLandingPageBSConfig();


        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        function loadLandingPageBSConfig() {
            BookingService.loadLandingPageBSConfig().then(function (data) {
                vm.landingPage = data;
                if (vm.landingPage.LandingPageBuchungssystem) {
                    if (window.location !== window.parent.location) {
                        if (_.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "http") || _.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "https")) {
                            vm.landingPageNewTabWithout = true;
                        } else {
                            vm.landingPageNewTabWith = true;
                        }

                        // The page is in an iframe
                    } else {
                        if (_.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "http") || _.startsWith("https", vm.landingPage.LandingPageUrlBuchungssystem, "https")) {
                            vm.landingPageWithout = true;
                        } else {
                            vm.landingPageWith = true;
                        }
                        // The page is not in an iframe
                    }
                }
            })
        }

        var logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'meetingData', 'meetingDate', 'kursData');
            //unregisterEventHandler();
            $state.go('kursplan', {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});

        });
        BookingService.getCurrency().then(function (data) {
            vm.currency = data;
            if (vm.currency.Waehrung === "EUR")
                vm.currency.Waehrung = "€";
        });

        $scope.$on("destroy", function () {
            logoutHandler();
        });
        vm.clubId = SessionService.getAuthData();

        if ($stateParams.message)
            vm.message = $stateParams.message;

        if (!SessionService.getSessionId()) {
            $state.go("kursplan", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        }


    }]);
